import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Tag from "sushiweb/Tag";
import Table from "../Common/Table";
import * as UserActions from "../../store/actions/User";
import styled from "styled-components";
import Button from "sushiweb/Button";
import TableFields from "../../constants/Namespace/NamespaceTableFields.json";
import * as ConfigChangeLogActions from "../../store/actions/Namespace";
import { Pill } from "../../constants/assets/containers";
import { getPath } from "../../utils";
import NamespaceModal from "./Modal";
import black from "sushiweb/tokens/color/black";
import _ from "lodash-es";
import ActionsModal from "../FeatureConfig/ActionsModal";
import { getEntityIds } from "../../store/actions/FeatureConfig";
import RevertModal from "../FeatureConfig/RevertModal";

const NamespaceList = (props) => {
  const [modalState, setModalState] = useState(false);
  const [activeNamespace, setActiveNamespace] = useState(null);
  const [actionsRequired, setActionsRequired] = useState({});
  const [activeVal, setActiveVal] = useState("");
  const { namespaces, setNamespaces } = props;
  const [initialState, setInitialState] = useState({
    activeActions: {},
  });

  const handleClick = (type, data) => {
    let values = { ...initialState };
    values["activeActions"] = data;
    setInitialState(values);
    setModalState(type);
  };

  const handleRevertClick = (type, log) => {
    setActiveNamespace(getPath(log, "namespace", ""));
    setModalState(type);
  };

  const handleSyncNow = (namespace) => {
    props.syncNamespace({
      namespace: namespace,
    });
  };

  const handleEditClick = (type, log) => {
    let values = { ...initialState };
    setActionsRequired({
      read: _.cloneDeep(log.namespaceActions?.read) || [],
      write: _.cloneDeep(log.namespaceActions?.write) || [],
    });
    setInitialState(values);
    const rules = log?.rules?.map((rule) => {
      return {
        ...rule,
        id: getEntityIds(rule.entities || []),
        activeEntity: { id: getEntityIds(rule.entities || []) },
      };
    });
    setActiveNamespace({
      ...log,
      rules: rules,
    });
    setModalState(type);
  };

  const handleModalClose = () => {
    setActiveNamespace(null);
    setActiveVal("");
    setModalState(false);
  };

  const getFieldValue = (log, key, idx) => {
    switch (key) {
      case "dirty":
      case "synced":
        const isSynced = getPath(log, key, false);
        const text = isSynced ? "Yes" : "No";
        return <Pill isFalse={!isSynced}>{text}</Pill>;
      case "configActions":
      case "namespaceActions":
        return (
          <span
            onClick={() => handleClick(key, log[key])}
            className="cursor-pointer"
          >
            <p
              style={{
                color: black,
                textDecoration: "underline",
                textDecorationColor: black,
              }}
            >
              {"view"}
            </p>
          </span>
        );
      case "sync":
        return (
          <Button
            size="small"
            btnColor="coal"
            onClick={() => handleSyncNow(getPath(log, "namespace", ""))}
          >
            Force Sync
          </Button>
        );
      case "revert":
        return (
          <Button
            size="small"
            btnColor="coal"
            onClick={() => handleRevertClick(key, log)}
          >
            Revert
          </Button>
        );
      case "edit":
        return (
          <span
            onClick={() => handleEditClick(key, log)}
            className="cursor-pointer"
          >
            <p
              style={{
                color: black,
                textDecoration: "underline",
                textDecorationColor: black,
              }}
            >
              {"edit"}
            </p>
          </span>
        );
      default:
        return getPath(log, key, "NA");
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "configActions":
      case "namespaceActions":
        return (
          <ActionsModal
            handleClose={handleModalClose}
            activeActions={getPath(initialState, "activeActions", {})}
          ></ActionsModal>
        );
      case "edit":
        return (
          <NamespaceModal
            modalState={modalState}
            activeNamespace={activeNamespace}
            handleClose={handleModalClose}
            setNamespaces={setNamespaces}
            actionsRequired={actionsRequired}
          ></NamespaceModal>
        );

      case "revert":
        return (
          <RevertModal
            modalState={modalState}
            activeNamespace={activeNamespace}
            handleClose={handleModalClose}
            syncNamespace={props.syncNamespace}
            getNamespaceVersions={props.getNamespaceVersions}
          ></RevertModal>
        );
    }
  };

  return (
    <TableView>
      <Table
        list={namespaces}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      {!!modalState && getModal()}
    </TableView>
  );
};

const TableView = styled.section`
  height: calc(100vh - 200px);
`;
const mapStateToProps = (state) => {
  const { ConfigChangeLog, CityProperty, GenSetting } = state;
  return {
    GenSettingChangeLog: ConfigChangeLog.GenSettingChangeLog,
    activeCityProperty: CityProperty.activeCityProperty,
    activeGenSetting: GenSetting.activeGenSetting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNamespaces: bindActionCreators(
      ConfigChangeLogActions.getNamespaces,
      dispatch
    ),
    upsertNamespace: bindActionCreators(
      ConfigChangeLogActions.upsertNamespace,
      dispatch
    ),
    syncNamespace: bindActionCreators(
      ConfigChangeLogActions.syncNamespace,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getNamespaceVersions: bindActionCreators(
      ConfigChangeLogActions.getNamespaceVersions,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NamespaceList);
